import i18next from 'i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import { initReactI18next } from 'react-i18next';
import Backend from 'i18next-http-backend';

i18next
  .use(LanguageDetector)
  .use(initReactI18next)
  .use(Backend)
  .init({
    returnObjects: true,
    fallbackLng: 'tr',
    debug: false,
    // Çeviri dosyalarının adı hash'lenmiyor ve sunucu Cache-Control
    // göndermiyor; tarayıcı eski translation.json'ı önbellekten kullanınca
    // yeni eklenen anahtarlar ekranda ham haliyle görünüyordu.
    backend: {
      queryStringParams: { v: import.meta.env.VITE_BUILD_ID ?? 'dev' }
    }
  });

export const changeLanguage = (language: string) => {
  i18next.changeLanguage(language);
};
